module.exports = __webpack_public_path__ + "static/img/andreinaTopRight.dd07f2b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/aboutUs/romboTeam/Andreina/andreinaTopRight.png
// module id = 534
// module chunks = 1